<template>
  <div id="app" class="text-gray-600">
    <notifications group="foo" />
    <router-view></router-view>
  </div>
</template>

<script>
import Survey from "@/views/Survey";
import axios from "axios";
import VConsole from "vconsole";
import liff from "@line/liff";

export default {
  components: {
    survey: Survey,
  },
  async created() {
    // const vConsole = new VConsole();

    this.lineInit();
  },
  methods: {
    async checkTokenExpiration() {},

    async lineInit() {
      await liff.init({ liffId: process.env.VUE_APP_LIFF_ID });

      if (liff.isInClient()) {
        const profile = await liff.getProfile();

        if (localStorage.getItem("TOKEN") == null) {
          try {
            const response = await axios({
              method: "POST",
              url: `${process.env.VUE_APP_API_URL}/me/check/line`,
              data: {
                lineId: profile.userId,
              },
            });

            const { token } = response.data;
            localStorage.setItem("TOKEN", token);

            this.$notify({
              type: "success",
              group: "foo",
              title: "เข้าสู่ระบบผู้ใช้สำเร็จ",
              text: "ยินดีต้อนรับ",
            });

            this.$router.push({ path: "/assessments" });
          } catch (error) {
            console.log(error);
          }
        }
      }
    },
  },
};
</script>

<style>
/* @import "./assets/tailwind.css"; */

@import url("https://fonts.googleapis.com/css?family=Sarabun:200,300,400,500,600,700&display=swap&subset=thai");

#app {
  font-family: "Sarabun", sans-serif;
}

.anticon {
  vertical-align: 0;
}

.ant-form label {
  font-size: 16px;
}
</style>
